import { render, staticRenderFns } from "./withholdInfo.vue?vue&type=template&id=1302a19a"
import script from "./withholdInfo.vue?vue&type=script&lang=js"
export * from "./withholdInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports